// extracted by mini-css-extract-plugin
export default {"content":"Cookies_content__9ayG6","contentValue":"Cookies_contentValue__xyJPt"};